module.exports = __webpack_public_path__ + "static/media/view4.b222bd61.jpg";